import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/solicitudes-percepciones-periodos';

/**
 * GET Solicitudes Percepciones Periodos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudesPercepcionesPeriodos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Solicitud Percepcion Periodo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSolicitudPercepcionPeriodo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Solicitud Percepcion Periodo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSolicitudPercepcionPeriodo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Solicitud Percepcion Periodo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSolicitudPercepcionPeriodo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Solicitud Percepcion Periodo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSolicitudPercepcionPeriodo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Solicitudes Percepciones Periodos (masivo)
 * @param {Array} values
 * @returns {Promise<boolean>}
 */
export const postSolicitudesPercepcionesPeriodos = async (values) => {
  try {
    const URI = 'nominas/agregar-solicitudes-percepciones-periodos/';
    const mensaje = values?.length > 1 ? 'Agregados correctamente' : 'Agregado correctamente';
    const response = await API.post(URI, values);
    onSuccess(response, mensaje);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
